import { RootState } from "@/app/stores"
import { createIntegration, deleteIntegration, ICreateIntegration, IIntegration, IUpdateIntegration, updateIntegration } from "@/shared/api/settings"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchUpdateUserIntegration = createAsyncThunk<
    IIntegration,
    IUpdateIntegration,
    { state: RootState }
>(`updateUserIntegration/fetchUpdateUserIntegration`, async(data, thunkAPI) => {
    try {
        const response = await updateIntegration(data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
export const fetchCreateUserIntegration = createAsyncThunk<
    IIntegration,
    ICreateIntegration,
    { state: RootState }
>(`updateUserIntegration/fetchCreateUserIntegration`, async(data, thunkAPI) => {
    try {
        const response = await createIntegration(data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
export const fetchDeleteUserIntegration = createAsyncThunk<
    void,
    void,
    { state: RootState }
>(`updateUserIntegration/fetchDeleteUserIntegration`, async(_, thunkAPI) => {
    try {
        const response = await deleteIntegration()
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})